import NextNProgress from 'nextjs-progressbar';
import { colours } from '../../stylings';

export function NextNProgressBar() {
  return <NextNProgress color={colours.VIVID_SKY} options={{ showSpinner: false }} />;
}
export default NextNProgressBar;
